import { render, staticRenderFns } from "./MemberProfileList.vue?vue&type=template&id=2f6d0bc2&scoped=true"
import script from "./MemberProfileList.vue?vue&type=script&lang=js"
export * from "./MemberProfileList.vue?vue&type=script&lang=js"
import style0 from "./MemberProfileList.vue?vue&type=style&index=0&id=2f6d0bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6d0bc2",
  null
  
)

export default component.exports